import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environmet';
import {
  PagedAiPresetsResponse,
  ApiResponse,
  PresetResponse,
  UpdatePresetCategoryRequest,
} from '../models/ai-presets.models';

@Injectable({
  providedIn: 'root',
})
export class AiPresetsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/presets`;

  getPresets(offset: number = 0, limit: number = 20): Observable<PagedAiPresetsResponse> {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString());

    return this.http.get<PagedAiPresetsResponse>(this.baseUrl, { params });
  }

  deletePreset(perfectlyClearPresetId: string): Observable<{ success: boolean; message: string; data?: string }> {
    return this.http.delete<{ success: boolean; message: string; data?: string }>(`${this.baseUrl}/${perfectlyClearPresetId}`);
  }

  uploadPreset(name: string, description: string, file: File, categoryId?: number): Observable<{ success: boolean; message?: string }> {
    const formData = new FormData();
    formData.append('Name', name);
    if (description) {
      formData.append('Description', description);
    }
    if (categoryId) {
      formData.append('PresetCategoryId', categoryId.toString());
    }
    formData.append('file', file);

    return this.http.post<{ success: boolean; message?: string }>(this.baseUrl, formData);
  }

  updatePresetCategory(
    presetId: number,
    request: UpdatePresetCategoryRequest
  ): Observable<ApiResponse<PresetResponse>> {
    return this.http.put<ApiResponse<PresetResponse>>(
      `${this.baseUrl}/${presetId}/category`,
      request
    );
  }
}
